import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login"; // Added import for Login component

const SecureAuth = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showNotFound, setShowNotFound] = useState(false);
  const navigate = useNavigate();

  // Check if user is already authenticated
  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      verifyToken(token);
    } else {
      setIsLoading(false);
      // Show 404 instead of redirecting
      setShowNotFound(true);
    }
  }, [navigate]);

  const verifyToken = async (token) => {
    try {
      const response = await fetch("/api/auth/verify", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setIsAuthenticated(true);
        setShowNotFound(false); // ✅ Reset showNotFound when token is valid
      } else {
        localStorage.removeItem("admin_token");
        localStorage.removeItem("admin_user");
        setShowNotFound(true);
      }
    } catch (error) {
      console.error("Token verification error:", error);
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");
      setShowNotFound(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
    setIsAuthenticated(false);
    navigate("/");
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Đang xác thực...</p>
        </div>
      </div>
    );
  }

  // Show login form if not authenticated
  if (showNotFound || !isAuthenticated) {
    return <Login />; // Show login form instead of 404
  }

  return children;
};

export default SecureAuth;
